<template>
  <div>
    <template v-for="(group, gIndex) in pairedOrders">
      <div class="a5-pagex" :key="'group-' + gIndex">
        <template v-for="(value) in group">
          <div class="barcodeprintx pagebarcodex" :key="value.barcode">
        <div class="label-pagex">
          <div class="label-leftx">
            <div class="logo-rowx">
              <!--<img class="yk-logo" :src="logoSrc" alt="YK" />-->
              <div class="order-number uppercasex">{{ orderNumbers(value.items) }}</div>
              <div class="order-metax">
                <div class="order-date uppercasex">{{ value.orderDate | formatDate }}</div>
              </div>
            </div>

            <div class="info-groupx">
              <div class="side-labelsx">
                <div class="side-labelx uppercasex">GON.</div>
                <div class="side-separatorx"></div>
                <div class="side-labelx uppercasex">ALICI</div>
              </div>
              <div class="info-mainx">
                <div class="info-topx">
                  <div class="info-outerx">
                    <div class="shipper-blockx info-content">
                      <div class="shipper uppercasex">{{ normalizeText(getCargoName(value.barcode) || '') }}</div>
                    </div>
                    <div class="dividerx"></div>
                    <div class="receiver-blockx info-content">
                      <div class="recipient uppercasex">{{ normalizeText(value.recipientName) }}</div>
                      <div class="address uppercasex">{{ normalizeText(value.shippingAddressDetail) }}</div>
                      <div class="address uppercasex">
                        {{ normalizeText(value.shippingDistrict) }} {{ normalizeText(value.shippingCity) }}
                      </div>
                      <div class="phone uppercasex">{{ value.phoneNumber }}</div>
                    </div>
                  </div>
                </div>
                <div class="group-separatorx"></div>
                <div class="green-boxx uppercasex">
                  <div>1/1 MI GO - AT</div>
                  <div>0.00 - KG 1.00 - DS 1.00 - KG/DESI</div>
                  <div class="green-separatorx"></div>
                  <div>Kurye Alan No:0 (0)</div>
                </div>
              </div>
            </div>

          </div>

          <div class="label-rightx">
            <div class="indicatorx">{{ value.indicator }}</div>
          </div>
        </div>
        <div class="barcode-sectionx">
              
              <div class="barcode-wrapperx">
                <barcode
                  class="barcode-imgx"
                  v-bind:value="value.barcode"
                  format="CODE128"
                  width="2"
                  :displayValue="false"
                >Barkod basılamadı tekrar deneyiniz.</barcode>
                <div class="barcode-textx uppercase">{{ value.barcode }}</div>
              </div>
            </div>
      </div>
        </template>
      </div>
    </template>
  </div>
</template>

<style>
* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  background-color: #fafafa;
  font-family: Arial, Helvetica, sans-serif;
}

.pagebarcodex {
  width: 11cm;
  height: 7.8cm;
  min-height: 7.8cm;
  max-height: 7.8cm;
  margin: 0;
  padding: 0;
  background: #ffffff;
  overflow: hidden;
  flex-shrink: 0;
  position: relative;
  padding-top: 0px;
  
}

.label-pagex {
  width: 100%;
  height: 100%;
  padding: 4px;
  display: flex;
  gap: 0;
  font-family: Arial, Helvetica, sans-serif;
  align-items: flex-start;
  font-weight: 700;
}

.label-pagex * {
  font-weight: 700;
}

.label-leftx {
  flex: 1;
  min-width: 0;
  max-width: 65%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow: hidden;
}

.logo-rowx {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  min-height: 34px;
  width: 100%;
}

.yk-logox {
  height: 30px;
  object-fit: contain;
}

.order-metax {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 11px;
  line-height: 1.2;
  margin-left: auto;
  align-items: flex-start;
}

.info-groupx {
  display: flex;
  align-items: stretch;
}

.side-labelsx {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  margin-top: 4px;
  margin-right: 4px;
}

.side-labelx {
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  font-weight: 700;
  letter-spacing: 0.5px;
  padding: 6px 3px;
  font-size: 11px;
}

.side-separatorx {
  height: 8px;
}

.info-mainx {
  flex: 1;
  border: 1px solid #000;
  display: flex;
  flex-direction: column;
}

.info-topx {
  display: flex;
}

.info-outerx {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 130px;
}

.shipper-blockx {
  padding: 6px 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  line-height: 1.2;
  min-height: 30px;
}

.receiver-blockx {
  padding: 6px 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  line-height: 1.2;
  min-height: 120px;
}

.dividerx {
  border-top: 1px solid #000;
}

.group-separatorx {
  border-top: 1px solid #000;
}

.shipperx {
  font-weight: 700;
}

.recipientx {
  font-weight: 700;
  font-size: 16px;
}

.green-boxx {
  padding: 6px 8px 6px 8px;
  font-size: 12px;
  line-height: 1.25;
  border: 1px solid #2d7a32;
}

.green-separatorx {
  border-top: 1px solid #2d7a32;
  margin-top: 4px;
  padding-top: 4px;
}

.city-bigx {
  font-size: 26px;
  font-weight: 800;
  margin-top: 6px;
  margin-left: 18px;
}

.label-rightx {
  width: 35%;
  min-width: 35%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding-top: 2px;
  overflow: hidden;
}

.indicatorx {
  font-size: 50px;
  font-weight: 800;
  line-height: 1;
}

.barcode-sectionx {
  
  position: absolute;
  right: -30px;
  top: 80px;
  rotate: -90deg;
}

.vertical-orderx   {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 0;
  font-size: 11px;
  line-height: 1;
  margin: 0;
  padding: 0;
  flex-shrink: 0;
}

.vertical-label-boxx,
.vertical-number-boxx {
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  text-align: center;
  display: block;
  padding: 0;
  margin: 0;
}

.vertical-number-boxx {
  font-weight: 700;
}

.barcode-wrapperx {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  transform-origin: center;
  margin-left: -50px;
}

.barcode-imgx {
  display: block;
  object-fit: contain;
  width: 90%;

}

.barcode-imgx svg {
  display: block;
  object-fit: contain;
  width: 90%;
}

.barcode-textx {
  margin-right: 50px;
  font-size: 16px;
  letter-spacing: 1px;
  font-weight: 400;
  margin-top: -15px  ;
  
}

.uppercasex {
  text-transform: uppercase;
}

.a5-pagex {
  width: 14.8cm;
  height: 21cm;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.5cm 0;
  gap: 0.5cm;
  background: #ffffff;
  page-break-after: always;
  margin: 0.5cm auto;
  border: 1px dashed #ccc;
  overflow: hidden;
}

@page {
  margin: 0;
}

@media print {
  @page {
    margin: 0; 
  }
  html,
  body {
    width: initial !important;
    height: initial !important;
  }

  .a5-pagex {
    margin: 0;
    padding: 0.5cm 0;
    page-break-after: always;
    border: none;
    overflow: hidden;
  }

  .pagebarcodex {
    margin: 0;
    border-radius: initial;
    width: 11cm;
    height: 7.8cm;
    min-height: 7.8cm;
    max-height: 7.8cm;
    box-shadow: initial;
    background: #fff;
    page-break-after: auto;
    overflow: hidden;
    flex-shrink: 0;
    padding-top: 0px;
  }
}
</style>

<script>
import VueBarcode from "vue-barcode";

export default {
  data: () => ({
    orders: [],
    // logoSrc: ykLogo
  }),

  components: {
    barcode: VueBarcode
  },

  computed: {
    pairedOrders() {
      const pairs = [];
      for (let i = 0; i < this.orders.length; i += 2) {
        const pair = [this.orders[i]];
        if (this.orders[i + 1]) {
          pair.push(this.orders[i + 1]);
        }
        pairs.push(pair);
      }
      return pairs;
    }
  },

  methods: {
    orderNumbers(items) {
      if (!items) return "";
      return [...new Set(items.map(p => p.orderNumber))].join(", ");
    },
    normalizeText(text) {
      if (!text) return "";
      const map = {
        İ: "I",
        I: "I",
        ı: "I",
        i: "I",
        Ş: "S",
        ş: "S",
        Ğ: "G",
        ğ: "G",
        Ü: "U",
        ü: "U",
        Ö: "O",
        ö: "O",
        Ç: "C",
        ç: "C"
      };
      const replaced = text
        .toString()
        .split("")
        .map(ch => (map[ch] ? map[ch] : ch))
        .join("");
      return replaced.toUpperCase();
    },
    getCargoName(item) {
      if (!item) return "";
      if (item.startsWith("627")) return "HEPSIJET";
      if (item.startsWith("625")) return "MNG";
      return "HEPSIBURADA - ID** *******";
    }
  },
  mounted() {
    this.$store.commit("SET_LAYOUT", "empty-layout");
    this.orders = JSON.parse(sessionStorage.getItem("barcodeprint")).sort(
      function(a, b) {
        return a.indicator > b.indicator ? 1 : -1;
      }
    );
    window.print();
  }
};
</script>
